import { Component, OnInit , ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-learn-more',
    templateUrl: './learn-more.component.html',
    styleUrls: ['./learn-more.component.scss'],
    standalone: false
})
export class LearnMoreComponent implements OnInit {


  isAbout:boolean | string = false
  constructor(private activatedRoute:ActivatedRoute, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.isAbout = params['isAbout']
     this.isAbout === "true" ? this.isAbout = true : this.isAbout = false;
      this.cdr.detectChanges();
    })
  }

}
